import { generatePath } from 'react-router-dom';
import { ApiCacheTags, ApiCacheTagsArray, baseApiService } from '@qapline/api';
import { carrierSchema, TCarrier } from '@qapline/core/carrier';
import { TagDescription } from '@reduxjs/toolkit/query';
import { config } from 'config';

import { TCreateCarrierRequestBody, TUpdateCarrierRequestBody } from '../types';

const { update: updateEndpoint, create: createEndpoint, delete: deleteEndpoint } = config.api.endpoints.carrier;
const { item: itemTag } = ApiCacheTags.carrier;

export const carrierApi = baseApiService.injectEndpoints({
    endpoints: (builder) => ({
        createCarrier: builder.mutation<TCarrier, TCreateCarrierRequestBody>({
            query: ({ ...data }) => {
                return {
                    url: createEndpoint,
                    method: 'POST',
                    body: data,
                };
            },
            invalidatesTags: (_res, error, _args) => {
                if (error) return [];
                const tags: TagDescription<(typeof ApiCacheTagsArray)[number]>[] = [ApiCacheTags.carrier.list];
                return tags;
            },
            transformResponse: (data) => carrierSchema.parse(data),
        }),

        updateCarrier: builder.mutation<TCarrier, TUpdateCarrierRequestBody>({
            query: ({ carrier_id, ...data }) => {
                return {
                    url: generatePath(updateEndpoint, { carrierId: carrier_id.toString() }),
                    method: 'PUT',
                    body: data,
                };
            },
            invalidatesTags: (_res, error, { carrier_id }) => {
                if (error) return [];
                const tags: TagDescription<(typeof ApiCacheTagsArray)[number]>[] = [ApiCacheTags.carrier.list];
                tags.push({ type: itemTag, id: carrier_id });
                return tags;
            },
            transformResponse: (data) => carrierSchema.parse(data),
        }),

        deleteCarrier: builder.mutation<void, number>({
            query: (carrier_id) => ({
                url: generatePath(deleteEndpoint, { carrierId: carrier_id.toString() }),
                method: 'DELETE',
            }),
            invalidatesTags: (_, error) => (error ? [] : [ApiCacheTags.carrier.list]),
        }),
    }),
});

export const { useCreateCarrierMutation, useUpdateCarrierMutation, useDeleteCarrierMutation } = carrierApi;
